import React from 'react';

const Stack = ({ children }) => {
  return <div style={{ padding: '2em' }}>{children}</div>;
};

export default Stack;
